import { FormikProps } from 'formik'
import { setNumberTo2DecimalsOnly } from '@src/helpers/numberHelpers'
import { updateDays } from '@src/ui/components/Admin/Shifts/ShiftEditDuplicate/utils'
import { INewEditModalFormValues } from '../../new-edit-modal.form'

export const handlePayRateChange = (
  e: React.ChangeEvent<HTMLInputElement>,
  formik: FormikProps<INewEditModalFormValues>
) => {
  const { values, setValues } = formik

  const payValue = setNumberTo2DecimalsOnly(e.target.value)

  const days = updateDays(values.days, {
    pay_value: payValue,
  })

  setValues({
    ...values,
    pay_value: payValue || '',
    days,
  })
}

// Handle days change
export const handlePositionsChange = (
  e: React.ChangeEvent<HTMLInputElement>,
  formik: FormikProps<INewEditModalFormValues>
) => {
  const { setFieldValue, values } = formik
  const rawValue = e.target.value
  if (rawValue === '') {
    setFieldValue('positions', '')
    return
  }
  let positions = Number(setNumberTo2DecimalsOnly(rawValue))
  if (positions < 0) positions = 0
  setFieldValue('positions', positions)
}
